import React, { useState } from "react";
import { TextInput, Text, TextInputProps, View, StyleSheet } from "react-native";
import { FONT } from "../../value/staticValues";

interface InputTextProps {
    inputref?: React.RefObject<any>;
    inputprops: TextInputProps;
    error?: boolean;
    text?: string;
    value?: string;
    fontsize?: number;
    size?: {
        width?: number;
        height?: number;
    }
}

export function InputTextUnderLine(props: InputTextProps) {
    const [status, setStatus] = useState(false)
    const [focus, setFocus] = useState(false)

    const styles = StyleSheet.create({
        input_textbox: {
            width: "100%",
            borderStyle: 'solid', borderBottomWidth: 1, borderColor: "#bfbfbf",
            paddingTop: 15,
            paddingBottom: 10,
            fontFamily: FONT.REGULAR,
            fontSize: 16,
            color: "#222"
        },
        input_error: {
            borderColor: "#db4d30",
            color: "#222"
        },
        focus_textbox: {
            borderColor: "rgba(99, 122, 255, 0.8)",
        },
        input_textbox_label_style: {
            marginBottom: -30,
            fontFamily: FONT.REGULAR,
            fontSize: 20,
            color: "#adb0b3",
        },
        input_textbox_label_active_style: {
            marginBottom: 0,
            fontFamily: FONT.REGULAR,
            fontSize: 14,
            color: "#8c9299",
        },
    });

    return (
        <View style={{
            minHeight: props.size?.height || 85,
            justifyContent: "flex-end"
        }}>
            <Text style={status || props.value ?
                props.error?
                    [styles.input_textbox_label_active_style, {color: "#db4d30"}]
                : focus?
                    [styles.input_textbox_label_active_style, {color: "#637aff"}]
                : styles.input_textbox_label_active_style
            : styles.input_textbox_label_style}>
                {status || props.value ? props.text: props.inputprops.placeholder}
            </Text>
            <TextInput
                {...props.inputprops}
                ref={props.inputref}
                style={props.error? {...styles.input_textbox, ...styles.input_error} : focus? {...styles.input_textbox, ...styles.focus_textbox} : styles.input_textbox}
                value={props.value}
                placeholder={undefined}
                onFocus={() => {
                    setStatus(true);
                    setFocus(true);
                }}
                onBlur={(event) => {
                    if(event.nativeEvent.text === '') { setStatus(false); }
                    setFocus(false);
                }}
                />
        </View>
    )
}


interface CustomTextInputProps {
    width: number;
    height: number;
    value: string;
    activeYn: boolean;
    inputCb: Function;
    warnYn: boolean;
    type: string;
    maxLength?: number;
    placeHolderText?: string;
}

export function CustomTextInput(props:CustomTextInputProps) {
    const [status, setStatus] = useState(false);

    return (
        <input
            maxLength={props.maxLength}
            type={props.type}
            style={{
                width: props.width? props.width : 300,
                height: props.height? props.height : 33,
                paddingLeft: 11,
                borderStyle: "solid", borderWidth: 0.8, borderRadius: 4,
                borderColor: status? "rgba(99, 122, 255, 0.8)" : props.warnYn? "#ff009a" : "#d2d5d9",
                backgroundColor: !props.activeYn ? "#f0f0f0" : status? "#f2f5f9" : "#fff",
                fontFamily: FONT.REGULAR,
                fontSize: 13,
                lineHeight: 0.92,
            }}
            defaultValue={props.value}
            disabled={!props.activeYn}
            placeholder={props.placeHolderText ? props.placeHolderText : ""}
            onInput={(e) => { props.inputCb(e.currentTarget.value); }}
            onFocus={(e) => { setStatus(true);}}
            onBlur={(e) => { setStatus(false);}}
        />

    );
}


interface TextAreaProps {
    id?: string,
    width: number,
    height: number,
    value: string,
    type: string,
    activeYn: boolean,
    inputCb: Function,
    warnYn: boolean,
    maxLength?: number,
    placeHolderText?: string;
}

export function TextArea(props:TextAreaProps) {
    const [focusYn, setFocusYn] = useState(false);

    return (
        <textarea
            maxLength={props.maxLength}
            style={{
                width: props.width || 300,
                height: props.height || 100,
                paddingLeft: 11, paddingTop: 9, paddingBottom: 9,
                borderStyle: "solid", borderWidth: 0.8, borderRadius: 4,
                borderColor: props.warnYn? "##ff009a" : focusYn? "rgba(99, 122, 255, 0.8)" : "#d2d5d9",
                outline: "none",
                fontFamily: FONT.REGULAR,
                fontSize: 13,
                backgroundColor: props.activeYn ? focusYn? "#f2f5f9" : "#ffffff" : "#f2f5f9",
                resize: "none"
            }}
            spellCheck={false}
            defaultValue={props.value}
            disabled={!props.activeYn}
            placeholder={props.placeHolderText ? props.placeHolderText : ""}
            onChange={(e) => { props.inputCb(e.target.value)}}
            onFocus={(e) => { setFocusYn(true); }}
            onBlur={(e) => { setFocusYn(false); }}
            onKeyPress={() =>{}}
        />
    );
}